import React, { Component } from 'react';
import { connect } from 'react-redux';

import { userSetSubjectsFetch } from './../../store/user/actions';

import Checkbox from './../Checkbox';

const MAX_COUNT = 7;

class MySubjectsForm extends Component {
    constructor(props) {
        super(props);

        this.onChange = this.onChange.bind(this);
        this.renderCheckbox = this.renderCheckbox.bind(this);
    }

    onChange(event) {
        const { target } = event;
        const { selectedSubjects, save } = this.props;
        const subjects = target.checked ? [...selectedSubjects, target.name] : selectedSubjects.filter(subject => subject !== target.name);
        save(subjects);
    }

    renderCheckbox(subject) {
        const { selectedSubjects, isLoading } = this.props;
        const selected = selectedSubjects.indexOf(subject) > -1;
        const disabled = isLoading || (selectedSubjects.length >= MAX_COUNT && !selected);
        return (
            <Checkbox
                key={subject}
                disabled={disabled}
                name={subject}
                checked={selected}
                onChange={this.onChange}
            >{subject}</Checkbox>
        );
    }

    render() {
        const { subjects } = this.props;
        const subjects1 = subjects.slice(0, Math.ceil(subjects.length / 2));
        const subjects2 = subjects.slice(Math.ceil(subjects.length / 2));
        return (
            <div className="subjects-box">
                <p>Please select subjects that you are ready to write about. You can choose not more than 7 preferred subjects at a time. Our team leaders will recommend you orders according to these subject preferences.</p>
                <div className="row">
                    <div className="col-1">
                        {subjects1.map(this.renderCheckbox)}
                    </div>
                    <div className="col-1">
                        {subjects2.map(this.renderCheckbox)}
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    selectedSubjects: (state.user.subjects || []).filter(subject => state.settings.orderSubjects.indexOf(subject) > -1),
    isLoading: state.user.isFetchingSubjects,
    subjects: state.settings.orderSubjects || []
});

const mapDispatchToProps = dispatch => ({
    save: subjects => dispatch(userSetSubjectsFetch(subjects))
});

export default connect(mapStateToProps, mapDispatchToProps)(MySubjectsForm);


// WEBPACK FOOTER //
// ./src/components/profile/MySubjectsForm.js